export const LINKS = {
  MOBILELIVE: "https://www.mobilelive.ca",
  NINJA: "https://ananinja.com/sa/en",
  PSEUDOSQUARE: "https://www.pseudosquare.com/",
  POSTS: "https://www.linkedin.com/in/waqarshahid/recent-activity/all/",
  DOTA: "https://steamcommunity.com/id/waqarshahid/",
  PHOTOGRAPHY: "https://www.flickr.com/photos/waqarshahidphotography",
  MUSIC: "https://www.youtube.com/@TvAkcent/videos",
  LINKEDIN: "https://www.linkedin.com/in/waqarshahid/",
  GITHUB: "https://github.com/mwaqarshahid",
  HOME: "/",
  RESUME_PDF: "/waqar-shahid-resume.pdf",
};

export const RESUME_DOWNLOAD_FILENAME = "Waqar-Shahid-Frontend-Developer.pdf";

export const PERSONAL = {
  NAME: "Waqar Shahid",
  THEME_KEY: "vkyTheme",
};

// Formspree form ID – replace with your form ID from https://formspree.io
// Form will POST to this endpoint and forward submissions to your email.
export const CONTACT_FORM_ACTION = "https://formspree.io/f/xaqdkoeq";

// Contact form field icons (SVG path data)
export const CONTACT_FORM_ICONS = {
  person: {
    viewBox: "0 0 24 24",
    path: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
  },
  phone: {
    viewBox: "0 0 24 24",
    path: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z",
  },
  email: {
    viewBox: "0 0 24 24",
    path: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z",
  },
  message: {
    viewBox: "0 0 24 24",
    path: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z",
  },
};

export const SOCIAL_ICON_SIZE = 22;

export const SOCIAL_ICONS = {
  Github: {
    viewBox: "0 0 24 24",
    path: "M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z",
  },
  LinkedIn: {
    viewBox: "0 0 24 24",
    path: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
  },
  Facebook: {
    viewBox: "0 0 24 24",
    path: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
  },
  Twitter: {
    viewBox: "0 0 24 24",
    path: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z",
  },
  Xing: {
    viewBox: "0 0 24 24",
    path: "M18.188 0c-.517 0-.741.325-.927.66 0 0-7.455 13.224-7.702 13.657.015.024 4.919 9.023 4.919 9.023.249.426-.372.644-.928.644H6.248c-.481 0-.651-.245-.651-.445 0-.214.314-.573.314-.573l3.018-5.049-4.693-8.054s-.291-.507-.291-.782c0-.244.173-.445.65-.445h3.455c.466 0 .607.249.733.458 0 0 2.985 5.178 3.101 5.364-.006-.013-5.037-8.876-5.038-8.876-.249-.486-.055-.668.578-.668h3.204c.497 0 .645.248.645.444 0 .218-.249.516-.249.516l-4.803 8.269 7.061 12.072c.094.159.252.445-.124.445h-3.24c-.494 0-.636-.248-.769-.458 0 0-3.729-6.431-3.875-6.667 0 .01 5.279 9.666 5.475 10.015.249.426-.087.652-.576.652h-6.021s-.93-.014-1.273-.639c-.258-.539-3.728-6.578-3.728-6.578-.249-.426.017-.638.576-.638h3.473c.454 0 .607.249.733.458 0 0 2.919 5.006 3.036 5.2-.006-.012-4.693-8.219-4.693-8.219-.249-.486-.055-.668.578-.668h3.204c.497 0 .645.248.645.444 0 .218-.249.516-.249.516z",
  },
};
